/** @prettier */
// Needed for redux devtools warning

/* eslint no-underscore-dangle: 0 */
import { fromJS } from 'immutable';
import { routerMiddleware as createRouterMiddleware } from 'react-router-redux';
import { applyMiddleware, compose, createStore } from 'redux';
import { combineReducers } from 'redux-immutable';
import createSagaMiddleware from 'redux-saga';

import accountActivityReducer from '@xanadu/ui-shared/modules/accountActivity/reducer';
import accountActivitySagas from '@xanadu/ui-shared/modules/accountActivity/sagas';
import affiliatesReducer from '@xanadu/ui-shared/modules/affiliates/reducer';
import affiliatesSagas from '@xanadu/ui-shared/modules/affiliates/sagas';
import { initialiseApp } from '@xanadu/ui-shared/modules/application/actions';
import applicationReducer from '@xanadu/ui-shared/modules/application/reducer';
import applicationSagas from '@xanadu/ui-shared/modules/application/sagas';
import betBuilderReducer from '@xanadu/ui-shared/modules/betBuilder/reducer';
import betBuilderSagas from '@xanadu/ui-shared/modules/betBuilder/sagas';
import betBuilderReportReducer from '@xanadu/ui-shared/modules/betBuilderReport/reducer';
import betBuilderReportSagas from '@xanadu/ui-shared/modules/betBuilderReport/sagas';
import betsReducer from '@xanadu/ui-shared/modules/bets/reducer';
import betsSagas from '@xanadu/ui-shared/modules/bets/sagas';
import betslipReducer from '@xanadu/ui-shared/modules/betslip/reducer';
import betslipSagas from '@xanadu/ui-shared/modules/betslip/sagas';
import carouselReducer from '@xanadu/ui-shared/modules/carousel/reducer';
import carouselSagas from '@xanadu/ui-shared/modules/carousel/sagas';
import cashierReducer from '@xanadu/ui-shared/modules/cashier/reducer';
import cashierSagas from '@xanadu/ui-shared/modules/cashier/sagas';
import cashoutReducer from '@xanadu/ui-shared/modules/cashout/reducer';
import cashoutSagas from '@xanadu/ui-shared/modules/cashout/sagas';
import casinoQuickLinksReducer from '@xanadu/ui-shared/modules/casinoQuickLinks/reducer';
import casinoQuickLinksSagas from '@xanadu/ui-shared/modules/casinoQuickLinks/sagas';
import currentBetReportReducer from '@xanadu/ui-shared/modules/currentBetReport/reducer';
import currentBetReportSagas from '@xanadu/ui-shared/modules/currentBetReport/sagas';
import dataLayerReducer from '@xanadu/ui-shared/modules/dataLayer/reducer';
import dataLayerSagas from '@xanadu/ui-shared/modules/dataLayer/sagas';
import depositLimitsReducer from '@xanadu/ui-shared/modules/depositLimits/reducer';
import depositLimitsSagas from '@xanadu/ui-shared/modules/depositLimits/sagas';
import eventReducer from '@xanadu/ui-shared/modules/event/reducer';
import eventSagas from '@xanadu/ui-shared/modules/event/sagas';
import eventParticipantsReducer from '@xanadu/ui-shared/modules/eventParticipants/reducer';
import eventsReducer from '@xanadu/ui-shared/modules/events/reducer';
import eventsSagas from '@xanadu/ui-shared/modules/events/sagas';
import feedbackReducer from '@xanadu/ui-shared/modules/feedback/reducer';
import inlineBetslipReducer from '@xanadu/ui-shared/modules/inlineBetslip/reducer';
import inlineBetslipSagas from '@xanadu/ui-shared/modules/inlineBetslip/sagas';
import liveScoresSagas from '@xanadu/ui-shared/modules/liveScores/sagas';
import lookupsReducer from '@xanadu/ui-shared/modules/lookups/reducer';
import lookupsSagas from '@xanadu/ui-shared/modules/lookups/sagas';
import marketReducer from '@xanadu/ui-shared/modules/market/reducer';
import marketSagas from '@xanadu/ui-shared/modules/market/sagas';
import marketRulesReducer from '@xanadu/ui-shared/modules/marketRules/reducer';
import marketRulesSagas from '@xanadu/ui-shared/modules/marketRules/sagas';
import modalReducer from '@xanadu/ui-shared/modules/modal/reducer';
import modalSagas from '@xanadu/ui-shared/modules/modal/sagas';
import multiplesReducer from '@xanadu/ui-shared/modules/multiples/reducer';
import multiplesSagas from '@xanadu/ui-shared/modules/multiples/sagas';
import multiplesReportReducer from '@xanadu/ui-shared/modules/multiplesReport/reducer';
import multiplesReportSagas from '@xanadu/ui-shared/modules/multiplesReport/sagas';
import navigationReducer from '@xanadu/ui-shared/modules/navigation/reducer';
import navigationSagas from '@xanadu/ui-shared/modules/navigation/sagas';
import openOffersReducer from '@xanadu/ui-shared/modules/openOffers/reducer';
import openOffersSagas from '@xanadu/ui-shared/modules/openOffers/sagas';
import popularMarketsReducer from '@xanadu/ui-shared/modules/popularMarkets/reducer';
import positionsReducer from '@xanadu/ui-shared/modules/positions/reducer';
import positionsSagas from '@xanadu/ui-shared/modules/positions/sagas';
import priceReducer from '@xanadu/ui-shared/modules/price/reducer';
import priceSagas from '@xanadu/ui-shared/modules/price/sagas';
import promotions from '@xanadu/ui-shared/modules/promotions';
import quickLinksReducer from '@xanadu/ui-shared/modules/quickLinks/reducer';
import quickLinksSagas from '@xanadu/ui-shared/modules/quickLinks/sagas';
import resetPasswordReducer from '@xanadu/ui-shared/modules/resetPassword/reducer';
import resetPasswordSagas from '@xanadu/ui-shared/modules/resetPassword/sagas';
import responsibleGamblingReducer from '@xanadu/ui-shared/modules/responsibleGambling/reducer';
import responsibleGamblingSagas from '@xanadu/ui-shared/modules/responsibleGambling/sagas';
import runnerReducer from '@xanadu/ui-shared/modules/runner/reducer';
import searchReducer from '@xanadu/ui-shared/modules/search/reducer';
import searchSagas from '@xanadu/ui-shared/modules/search/sagas';
import settledBets from '@xanadu/ui-shared/modules/settledBets';
import staticContentReducer from '@xanadu/ui-shared/modules/staticContent/reducer';
import staticContentSagas from '@xanadu/ui-shared/modules/staticContent/sagas';
import staticTextReducer from '@xanadu/ui-shared/modules/staticText/reducer';
import staticTextSagas from '@xanadu/ui-shared/modules/staticText/sagas';
import streamingReducer from '@xanadu/ui-shared/modules/streaming/reducer';
import streamingSagas from '@xanadu/ui-shared/modules/streaming/sagas';
import termsAndConditionsReducer from '@xanadu/ui-shared/modules/termsAndConditions/reducer';
import termsAndConditionsSagas from '@xanadu/ui-shared/modules/termsAndConditions/sagas';
import thirdPartyClientsReducer from '@xanadu/ui-shared/modules/thirdPartyClients/reducer';
import thirdPartyClientsSagas from '@xanadu/ui-shared/modules/thirdPartyClients/sagas';
import transactionsReducer from '@xanadu/ui-shared/modules/transactions/reducer';
import transactionsSagas from '@xanadu/ui-shared/modules/transactions/sagas';
import twoFactorAuthenticationReducer from '@xanadu/ui-shared/modules/twoFactorAuthentication/reducer';
import twoFactorAuthenticationSagas from '@xanadu/ui-shared/modules/twoFactorAuthentication/sagas';
import unsubmittedOffersReducer from '@xanadu/ui-shared/modules/unsubmittedOffers/reducer';
import unsubmittedOffersSagas from '@xanadu/ui-shared/modules/unsubmittedOffers/sagas';
import uploadDocsReducer from '@xanadu/ui-shared/modules/uploadDocs/reducer';
import uploadDocsSagas from '@xanadu/ui-shared/modules/uploadDocs/sagas';
import userReducer from '@xanadu/ui-shared/modules/user/reducer';
import userSagas from '@xanadu/ui-shared/modules/user/sagas';
import userRegistrationSagas from '@xanadu/ui-shared/modules/userRegistration/sagas';
import userSessionSagas from '@xanadu/ui-shared/modules/userSession/sagas';

import { routerReducer as routing } from './utils/immutable';
import createHistory from 'history/createBrowserHistory';
import { all, fork } from 'redux-saga/effects';

import { reducers, sagas } from './modules';

const { sagas: promotionsSagas, reducer: promotionsReducer } = promotions;

const { sagas: settledBetsSagas, reducer: settledBetsReducer } = settledBets;

const history = createHistory();
const enableDevTools = process.env.NODE_ENV !== 'production' && window.__REDUX_DEVTOOLS_EXTENSION__;

// Options for the redux devtools can be specified here. If you do specify
// See http://extension.remotedev.io/docs/API/Arguments.html for options
const reduxDevToolsOptions = {
  // NOTE: Do not commit any custom options
  // actionsWhitelist: ['price/']
};

if (Object.keys(reduxDevToolsOptions).length) {
  // eslint-disable-next-line no-console
  console.warn('Custom redux devtool options have been specified.', reduxDevToolsOptions);
}

const routerMiddleware = createRouterMiddleware(history);
const initialState = fromJS({});
const reducer = combineReducers({
  ...reducers,
  routing,
  application: applicationReducer,
  bets: betsReducer,
  accountActivity: accountActivityReducer,
  lookups: lookupsReducer,
  resetPassword: resetPasswordReducer,
  staticContent: staticContentReducer,
  staticText: staticTextReducer,
  streaming: streamingReducer,
  thirdPartyClients: thirdPartyClientsReducer,
  quickLinks: quickLinksReducer,
  search: searchReducer,
  affiliates: affiliatesReducer,
  carousels: carouselReducer,
  cashier: cashierReducer,
  cashout: cashoutReducer,
  casinoQuickLinks: casinoQuickLinksReducer,
  twoFactorAuthentication: twoFactorAuthenticationReducer,
  termsAndConditions: termsAndConditionsReducer,
  navigation: navigationReducer,
  dataLayer: dataLayerReducer,
  event: eventReducer,
  events: eventsReducer,
  eventParticipants: eventParticipantsReducer,
  multiples: multiplesReducer,
  betslip: betslipReducer,
  market: marketReducer,
  marketRules: marketRulesReducer,
  runner: runnerReducer,
  betBuilder: betBuilderReducer,
  user: userReducer,
  price: priceReducer,
  unsubmittedOffers: unsubmittedOffersReducer,
  popularMarkets: popularMarketsReducer,
  uploadDocs: uploadDocsReducer,
  settledBets: settledBetsReducer,
  depositLimits: depositLimitsReducer,
  betBuilderReport: betBuilderReportReducer,
  currentBetReport: currentBetReportReducer,
  transactions: transactionsReducer,
  multiplesReport: multiplesReportReducer,
  openOffers: openOffersReducer,
  positions: positionsReducer,
  inlineBetslip: inlineBetslipReducer,
  modal: modalReducer,
  promotions: promotionsReducer,
  responsibleGambling: responsibleGamblingReducer,
  feedback: feedbackReducer,
});
const sagaMiddleware = createSagaMiddleware();
const enhancer = compose(
  applyMiddleware(routerMiddleware, sagaMiddleware),
  enableDevTools ? window.__REDUX_DEVTOOLS_EXTENSION__(reduxDevToolsOptions) : (f) => f
);

let store;

/**
 * Returns the state of the store. Not recommended to use in react. Added for Backbone compatibility. Used for currency.
 * @return {Immutable#map} the contents of the redux store
 */
const dangerouslyGetState = () => (store ? store.getState() : initialState);

/**
 * Returns the store. Not recommended to use in react.
 * Added for dispatching actions from normal functions in sagas. Used for Customer onboarding.
 * @return {Immutable#map} the contents of the redux store
 */
const dangerouslyGetStore = () => store;

function* rootSaga() {
  yield all(
    [
      ...sagas,
      twoFactorAuthenticationSagas,
      termsAndConditionsSagas,
      quickLinksSagas,
      casinoQuickLinksSagas,
      multiplesSagas,
      carouselSagas,
      searchSagas,
      affiliatesSagas,
      cashierSagas,
      cashoutSagas,
      liveScoresSagas,
      lookupsSagas,
      betBuilderSagas,
      resetPasswordSagas,
      staticContentSagas,
      staticTextSagas,
      streamingSagas,
      thirdPartyClientsSagas,
      navigationSagas,
      eventSagas,
      eventsSagas,
      marketSagas,
      marketRulesSagas,
      priceSagas,
      userRegistrationSagas,
      uploadDocsSagas,
      depositLimitsSagas,
      betBuilderReportSagas,
      currentBetReportSagas,
      transactionsSagas,
      multiplesReportSagas,
      unsubmittedOffersSagas,
      accountActivitySagas,
      userSessionSagas,
      userSagas,
      applicationSagas,
      betsSagas,
      dataLayerSagas,
      betslipSagas,
      openOffersSagas,
      positionsSagas,
      modalSagas,
      responsibleGamblingSagas,
      inlineBetslipSagas,
      ...settledBetsSagas,
      ...promotionsSagas,
    ].map((saga) => fork(saga, { brand: 'matchbook' }))
  );
}

export default function configureStore() {
  store = createStore(reducer, initialState, enhancer);
  sagaMiddleware.run(rootSaga);

  store.dispatch(initialiseApp({ brand: 'matchbook' }));

  return store;
}

export { history, dangerouslyGetState, dangerouslyGetStore };
